export default "__VITE_ASSET__Cfczad7Q__"